import { MemberSubmission } from '../models/submissions/member-submission';
import { SubmissionStatusIdEnum } from '../models/enum/shared/submission-status-id.enum';
import { IpEmployerSubmission } from '../models/submissions/employer-submissions/ip-employer-submission';
import { EpEmployerSubmission } from '../models/submissions/employer-submissions/ep-employer-submission';
import { EmployerMemberSubmission } from '../models/submissions/employer-submissions/employer-member-submission';
import { Routes } from '../routes/routes';

export class SubmissionUtils {
  static getMemberSubmissionUrl(submission: MemberSubmission) {
    return Routes.ipViewMemberSubmissionDetails(submission.id);
  }

  static sortSubmissionsByRelevantDate(
    a: MemberSubmission | IpEmployerSubmission,
    b: MemberSubmission | IpEmployerSubmission
  ) {
    const dateA = SubmissionUtils.getRelevantDate(a);
    const dateB = SubmissionUtils.getRelevantDate(b);

    if (!dateA && !dateB) return 0;
    if (!dateA) return 1;
    if (!dateB) return -1;

    return new Date(dateB).getTime() - new Date(dateA).getTime();
  }

  static getRelevantDate(
    submission: MemberSubmission | IpEmployerSubmission | EpEmployerSubmission | EmployerMemberSubmission
  ) {
    if (submission.isApproved()) {
      return submission.completedDate;
    }

    switch (submission.statusId) {
      case SubmissionStatusIdEnum.Pending:
        return submission.createdDate;
      case SubmissionStatusIdEnum.Cancelled:
      case SubmissionStatusIdEnum.Completed:
        return submission.completedDate;
      case SubmissionStatusIdEnum.Submitted:
      case SubmissionStatusIdEnum.InReview:
        return submission.submittedDate;
      default:
        return null;
    }
  }
}
